import bgc1 from "../../assets/bgc1.webp";
import bgc2 from "../../assets/blog_big1.webp";
import bgc3 from "../../assets/bgc3.webp";

const sliderItems = [
  {
    id: 1,
    img: bgc1,
    alt: "Man pushing his limits during a gym session",
    title: "KEEP PUSHING FORWARD",
    text: "Building strength and endurance requires dedication and hard work. We provide the tools and support to help you achieve your fitness goals.",
  },
  {
    id: 2,
    img: bgc2,
    alt: "Woman pushing her boundaries in a fitness class",
    title: "NO EXCUSES, JUST RESULTS",
    text: "A healthy body and mind come from consistent training. Let us guide you through your fitness journey with tailored programs and expert advice.",
  },
  {
    id: 3,
    img: bgc3,
    alt: "Woman receiving support during a workout",
    title: "TRAIN WITH CONFIDENCE",
    text: "Our gym provides not only top-notch equipment but also a supportive environment to help you conquer your fitness goals with ease.",
  },
];

export default sliderItems;
